import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/installer-no-appointments.svg'


const _hoisted_1 = { class: "max-w-[996px] h-[calc(100vh-52px)] p-[31px] mx-auto overflow-y-auto" }
const _hoisted_2 = { class: "w-fit mx-auto flex flex-col items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-primary-text-color text-xl font-semibold tracking-[0.01rem] mt-[6px]" }
const _hoisted_5 = { class: "text-[#898790] text-base font-medium tracking-[0.01rem]" }
const _hoisted_6 = { class: "text-primary-text-color mt-[24px] mb-3 text-xl leading-8 font-semibold tracking-[0.01rem]" }
const _hoisted_7 = {
  key: 1,
  class: "w-full h-[35vh] short:h-[42vh] tall:h-[49vh] flex items-center justify-center"
}
const _hoisted_8 = { class: "flex flex-col items-center gap-2" }
const _hoisted_9 = { class: "text-[#898790] text-base leading-[26px] tracking-[0.01rem] font-medium" }


import InstallerProfileThreeBlocks from "./InstallerProfileThreeBlocks.vue";
import InstallerProfileTable from "./InstallerProfileTable.vue";
import { useTranslate } from "@/composables/useTranslate";
import { InstallationTermin } from "@/types";

type Props = {
  termins?: InstallationTermin[];
  workerName?: string;
  workerRole?: string;
  workerImage?: string;
  currentAppointment?: string;
  completedTermins?: number;
  completedTerminsPercentage?: number;
  bonus?: number;
  isReport: boolean;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'InstallerProfile',
  props: {
    termins: {},
    workerName: {},
    workerRole: {},
    workerImage: {},
    currentAppointment: {},
    completedTermins: {},
    completedTerminsPercentage: {},
    bonus: {},
    isReport: { type: Boolean }
  },
  setup(__props: any) {

const { t } = useTranslate();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.workerImage)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "w-[103px] h-[103px] rounded-[36px] object-cover",
            src: __props.workerImage,
            alt: "Installer image"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("h4", _hoisted_4, _toDisplayString(__props.workerName), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.workerRole), 1)
    ]),
    _createVNode(InstallerProfileThreeBlocks, {
      bonus: __props.bonus,
      "completed-termins": __props.completedTermins,
      "completed-termins-percentage": __props.completedTerminsPercentage,
      "current-appointment": __props.currentAppointment,
      termins: __props.termins?.length,
      "is-report": __props.isReport
    }, null, 8, ["bonus", "completed-termins", "completed-termins-percentage", "current-appointment", "termins", "is-report"]),
    _createElementVNode("div", null, [
      _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(t)("installers.appointments_this_month")), 1),
      (__props.termins && __props.termins.length > 0)
        ? (_openBlock(), _createBlock(InstallerProfileTable, {
            key: 0,
            termins: __props.termins
          }, null, 8, ["termins"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                src: _imports_0,
                alt: "No appointments yet"
              }, null, -1)),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("installers.no_termins_yet")), 1)
            ])
          ]))
    ])
  ]))
}
}

})